import React, {Component} from 'react'
import StyleSheet from 'styles/StyleSheet'
import {IconButton, Modal} from '@material-ui/core'
import ScrollLeftIcon from '@material-ui/icons/NavigateBefore'
import ScrollRightIcon from '@material-ui/icons/NavigateNext'
import { authorizedLink } from 'utils/AuthorizationUtils'

export default class ImageGallery extends Component {
  state = {activeIndex: 0, lightBox: false}

  handleScrollClick = by => () => {
    this.setState(({activeIndex}) => ({activeIndex: activeIndex + by}))
  }

  handleOpenLightBox = open => () => {
    this.setState({lightBox: open})
  }

  renderGallery = () => {
    const {images} = this.props
    const {activeIndex} = this.state
    return (
      <div className={styles.gallery}>
        <div className={styles.viewPort}>
          <ul className={styles.collection} style={{transform: `translateX(${activeIndex * -100}%)`}}>
            {images.map((image) => (
              <li key={image.id} className={styles.item}>
                <img alt={image.description} src={authorizedLink(image.imageUrls.original)}
                     className={styles.image} onClick={this.handleOpenLightBox(true)}/>
              </li>
            ))}
          </ul>
        </div>
        <IconButton color="primary" className={styles('scroll', 'scrollLeft')}
                    onClick={this.handleScrollClick(-1)} disabled={activeIndex <= 0}>
          <ScrollLeftIcon />
        </IconButton>
        <IconButton color="primary" className={styles('scroll', 'scrollRight')}
                    onClick={this.handleScrollClick(1)} disabled={activeIndex >= images.length - 1}>
          <ScrollRightIcon />
        </IconButton>
      </div>
    )
  }

  render = () => (
    <>
      {this.renderGallery()}
      <Modal onClose={this.handleOpenLightBox(false)} open={this.state.lightBox}
             className={styles.model} BackdropProps={{className: styles.modelBackdrop}}>
        {this.renderGallery(true)}
      </Modal>
    </>
  )
}

const styles = StyleSheet({
  gallery: {
    position: 'relative',
  },
  model: {
    '& $gallery': {
      width: '80vw',
      height: '80vh',
      marginTop: '10vh',
      marginLeft: '10vw',
      outline: 0,
      pointerEvents: 'none',
    },
    '& $scroll': {
      display: 'none'
    },
    '& $image': {
      maxHeight: '80vh',
      maxWidth: '80vw',
    }
  },
  modelBackdrop: {
    background: 'rgba(0,0,0,0.8)'
  },
  viewPort: {
    overflow: 'hidden',
  },
  collection: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    transition: 'transform 300ms'
  },
  item: {
    minWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    maxWidth: '100%',
    cursor: 'pointer',
  },
  scroll: {
    position: 'absolute',
    top: 'calc(50% - 24px)',
    background: 'rgba(255,255,255,0.2)',
    '&[disabled]': {
      background: 'transparent',
    },
    '& svg': {
      filter: 'drop-shadow(0 0 1px #fff)',
    },
  },
  scrollLeft: {
    left: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    paddingLeft: 6,
  },
  scrollRight: {
    right: 0,
    paddingRight: 6,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
})